import { AudiFootnoteServiceCreatorV1, } from './v1/footnote-service';
export function defineAudiFootnoteService() {
    const v1 = AudiFootnoteServiceCreatorV1();
    return {
        create: () => {
            return {
                '1.1.0': v1.create,
            };
        },
        dependencies: {},
        id: 'audi-footnote-service',
    };
}
//# sourceMappingURL=feature-service.js.map